<template>
	<div class="h-100">
		<div
			v-if="appIsInitialized"
			ref="wrapper"
			class="app-wrapper-embedded"
		>
			<ViewMode />
		</div>
		<LoadingSpinner
			v-else
			center
		/>
		<ParallelViewModal
			v-if="parallelView"
			:parallel-view="parallelView"
		/>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { EVENT, bus } from '@videotools/js/events';
import { LoadingSpinner } from '@components/loader';
import ParallelViewModal from '@components/ParallelViewModal';

import ViewMode from './pages/ViewMode';

export default {
	name:       'App',
	components: { ViewMode, LoadingSpinner, ParallelViewModal },
	data() {
		return {
			parallelView: null,
		};
	},
	computed: {
		...mapGetters({
			event:            'event/event',
			appIsInitialized: 'app/isInitialized',
			isFullscreen:     'device/isFullscreen',
		}),
	},
	watch: {
		isFullscreen: {
			handler:   'lockOrientation',
			immediate: true,
		},
	},
	async created() {
		this.syncInit();
		this.setAppTypeViewMode();
		// Activate If couchmode is needed on embeds
		// await this.loadEventExtra(this.event.id);
		this.setAppStateInitializing();
		this.syncSetup();
		this.setAppStateNormal();

		if (this.event) {
			this.$Analytics.trackEvent('Player', 'Loaded', {
				eventId:   this.event.id,
				eventName: this.event.name,
			});
		}
	},
	mounted() {
		bus.subscribe(EVENT.PARALLEL_VIEW_DETECTED, this.showParallelViewModal);
	},
	methods: {
		...mapActions({
			// loadEventExtra:          'event/loadEventExtra', // Activate If couchmode is needed on embeds
			setAppStateInitializing: 'app/setAppStateInitializing',
			setAppStateNormal:       'app/setAppStateNormal',
			setAppTypeViewMode:      'app/setAppTypeViewMode',
			syncInit:                'sync/init',
			syncSetup:               'sync/setup',
			lockOrientation:         'device/lockOrientation',
		}),
		showParallelViewModal(view) {
			// Show parallel view modal, but only if autoplay is not disabled
			if (new URLSearchParams(window.location.search).get('disableautoplay') != null) {
				this.parallelView = view;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.app-wrapper-embedded {
	width: 100%;
	height: 100%;
}

.h-100 {
	height: 100%;
}

.white-bg {
	background: var(--color-white);
}
</style>
